function mergeRefs(...refs) {
    return (value)=>{
        for (const ref of refs)if ('function' == typeof ref) ref(value);
        else if (null != ref) ref.current = value;
    };
}
export { mergeRefs };
